import React, { useEffect } from "react";
import CustomDropdown from "../../../components/CustomDropdown";
import { Formik, Field, Form, ErrorMessage } from "formik";
import CustomDataTable from "../../../components/CustomDataTable";
import { useDispatch, useSelector } from "react-redux";
import { requestProjectsListActionWithOutPagination } from "../../../Redux/ProjectState/ProjectActionCreator";
import { requestBudgetReport, setResetStateBudgetReport } from "../../../Redux/ReportsState/ReportsActionCreator";
import { toast } from "react-toastify";
import Hoc from "../../../components/HOC";

const Budget = () => {
  const dispatch=useDispatch();
  const projectsListState = useSelector((state) => state.ProjectsListWithOutPagination);
  const budgetReportReducer = useSelector((state) => state.BudgetReportReducer);
  const columns = [ 
    {name: "User Name", selector: (row) => row.username, sortable: true},
    {name: "Budget" , selector:(row) => row.budget, sortable: false},
    {name: "Total_Hours", selector: (row) => row.total_hours, sortable: false},
    ];

  const initialValues = { 
    project: "",
  };

   const projectsList= projectsListState?.response || [];
   useEffect(()=>{
    dispatch(requestProjectsListActionWithOutPagination());
    dispatch(setResetStateBudgetReport());
   },[])

   useEffect(() => {
         if (!budgetReportReducer?.loading && budgetReportReducer?.error) {
         toast.error("No Reports Found / Something went wrong");
         dispatch(setResetStateBudgetReport());
       }
     },[budgetReportReducer])

   const handleSubmit = (values) => {
    dispatch(requestBudgetReport({
      project: values.project,
      page: budgetReportReducer?.page,
      size: budgetReportReducer?.size,
    }))
    };

  const handlePageChange = (page,) => {
    dispatch(requestBudgetReport({
      project: budgetReportReducer?.project,
      page: page,
      size: budgetReportReducer?.size,
    }))
  };

  const handleRowsChange = (size) => {
    dispatch(requestBudgetReport({
      project: budgetReportReducer?.project,  
      page: 0,
      size: size,
    }))
  };
  

  return (
    <div className="w-full p-6">
      <Formik initialValues={initialValues} onSubmit={handleSubmit}>
        {({
          isSubmitting,
          values,
          errors,
          touched,
          resetForm,
          handleChange,
          setFieldValue,
        }) => (
          <Form className="flex flex-col md:flex-row lg:flex-row gap-5 my-2">
            <div className="lg:w-1/4 md:w-1/2 w-3/4">
               <CustomDropdown
                value={projectsList?.find((project) => project?.projectName === values?.project)}
                name="project"
                handleChange={(selectedOption) => {
                  setFieldValue("project", selectedOption?.projectName);
                }}
                customClasses="w-76 text-left"
                placeholder="Select project"
                options={projectsList}
                handleGetOptionValue={(option) => option.projectName}
                handleGetOptionName={(option) => option.projectName}
              />
            </div>

            <div className="flex justify-center md:justify-end ">
              <button
                type="submit"
                className="bg-primary hover:bg-primaryDark text-white  px-4 rounded-lg focus:outline-none focus:shadow-outline"
              >
                Submit
              </button>
            </div>
          </Form>
        )}
      </Formik>
      <CustomDataTable
            columns={columns}
            data={budgetReportReducer?.response?.content || []}
            paginationTotalRows={budgetReportReducer?.response?.totalElements}
            handleChangePage={handlePageChange}
            handleRowsChange={handleRowsChange}
            fixedHeaderScrollHeight={"59vh"}
      />
     </div>
  );
}
export default Hoc(Budget);
